import axios from 'axios';

let API_URL;
if (process.env.NODE_ENV === 'development') {
  API_URL = `https://${window.location.hostname}:5000/api`;
} else {
  API_URL = `/api`;
}

const publicApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

export default publicApi;
